import { jsx, jsxs } from "react/jsx-runtime";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
function defaultRenderOptions(options) {
  return options.map((option) => {
    const { label, value, disabled, icon } = option;
    return /* @__PURE__ */ jsxs(MenuItem, { value, disabled, "data-value": value, sx: { paddingX: 2 }, children: [
      !!icon && /* @__PURE__ */ jsx(ListItemIcon, { children: icon }),
      /* @__PURE__ */ jsx(ListItemText, { sx: { textAlign: icon ? "right" : "left" }, children: label })
    ] }, value);
  });
}
export {
  defaultRenderOptions
};
//# sourceMappingURL=defaultRenderOptions.js.map
